import { Button, Tooltip } from '@mui/material';
// import { isDeleteAllowed, isUpdateAllowed, isDepartmentUserRole } from '../../../utils/common-utils';
import { isDeleteAllowed, isUpdateAllowed, hasDepartmentUserMasterAccess } from '../../../utils/common-utils';
import { convertToCamelCaseFromUnderScore, formatDate } from '../../../../common-utilities/utils';
import { DATE_FORMATS } from '../../../../common-utilities/utils/constants';

const isRateContractExpired = (toDate) => {
  if (!toDate) return false;
  const d = new Date(toDate);
  const toDateOnly = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const now = new Date();
  const todayOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return toDateOnly < todayOnly;
};

export const getHeaderConfig = (editVendor, setDeleteDetails, viewHistory) => {
  const headers = [
    {
      label: 'Vendor Name',
      id: 'name',
    },
    {
      label: 'Vendor Code',
      id: 'vendorCode',
    },
    {
      label: 'Item Name',
      id: 'categoryType',
      render: (data) => {
        const { item = {} } = data;
        return item?.name;
      },
    },
    {
      label: 'Item Code',
      id: 'item.itemCode',
    },
    {
      label: 'Price',
      id: 'price',
    },
    {
      label: 'Tax Percentage',
      id: 'taxPercentage',
    },
    {
      label: 'Valid From',
      id: 'fromDate',
      render: (data) => formatDate(data.fromDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label: 'Valid To',
      id: 'toDate',
      render: (data) => formatDate(data.toDate, DATE_FORMATS['DD-MM-YYYY']),
    },
    {
      label:"Status",
      id:"status",
      render: (data) => {
        return `${convertToCamelCaseFromUnderScore(data.status)} ${data?.approvalId?.pendingWith ? `(${data?.approvalId?.pendingWith})` : ''}`;
      }
    },
    {
      label: 'Actions',
      id: 'actions',
      render: (data) => {
        const expired = isRateContractExpired(data.toDate);
        // const canEditVendorMapping = isUpdateAllowed('master_data') || isDepartmentUserRole();
        const canEditVendorMapping = isUpdateAllowed('master_data') || hasDepartmentUserMasterAccess();
        const editButton = (
          <Button
            disabled={!canEditVendorMapping || data?.status === 'approval_in_progress' || expired}
            variant="text"
            onClick={() => editVendor(data, 'EDIT')}
          >
            Edit
          </Button>
        );
        return (
          <>
            {expired ? (
              <Tooltip
                title={`Vendor Item Mapping has expired on ${formatDate(data.toDate, DATE_FORMATS['DD-MM-YYYY'])}`}
              >
                {/* span wrapper -- Tooltip needs a listener-attachable child, which a
                    disabled native button cannot be. */}
                <span>{editButton}</span>
              </Tooltip>
            ) : (
              editButton
            )}
            <Button
              variant="text"
              disabled={!isDeleteAllowed('master_data')||data?.status==="approval_in_progress"}
              onClick={() => setDeleteDetails(data)}
            >
              Delete
            </Button>
            <Button variant="text" onClick={() => viewHistory(data)}>
              History
            </Button>
          </>
        );
      },
    },
  ];
  return headers;
};
